import "../entrypoints/front-lib.js"

import "@front/shared/Memo.js"
import "@front/shared/_on_ready.js"
import "@front/shared/_stimulus_setup.js"
import "@front/shared/activity.js"
import "@front/shared/b2b-notification-tracking.js"
import "@front/shared/booking-cancellation.js"
import "@front/shared/bugsnag.js"
import "@front/shared/cancellation-summary-details.js"
import "@front/shared/collapsible_content.js"
import "@front/shared/controllers/activity_controller.js"
import "@front/shared/controllers/auth_tracking_controller.js"
import "@front/shared/controllers/bnr_controller.js"
import "@front/shared/controllers/booking_cancellation_final_confirmation_controller.js"
import "@front/shared/controllers/collapsible_content_controller.js"
import "@front/shared/controllers/custom_content_missing_controller.js"
import "@front/shared/controllers/email_typo_controller.js"
import "@front/shared/controllers/faq_categories_controller.js"
import "@front/shared/controllers/favourite_button_controller.js"
import "@front/shared/controllers/link_controller.js"
import "@front/shared/controllers/new_pin_controller.js"
import "@front/shared/controllers/photo_prefetch_controller.js"
import "@front/shared/controllers/pin_controller.js"
import "@front/shared/stimulus_uses/use_outer_click.js"
import "@front/shared/controllers/popup_modal_controller.js"
import "@front/shared/controllers/prefetch_lazy_controller.js"
import "@front/shared/controllers/pricing_view_mode_controller.js"
import "@front/shared/controllers/room_leisure_controller.js"
import "@front/shared/controllers/search/destination_preload_controller.js"
import "@front/shared/controllers/search/form_controller.js"
import "@front/shared/controllers/search/group_card_controller.js"
import "@front/shared/controllers/search/group_configuration_controller.js"
import "@front/shared/controllers/search/idea_controller.js"
import "@front/shared/controllers/search/idea_desktop_controller.js"
import "@front/shared/controllers/search/location_form_controller.js"
import "@front/shared/controllers/search/panel_controller.js"
import "@front/shared/controllers/search/recent_searches_controller.js"
import "@front/shared/controllers/search/summary_controller.js"
import "@front/shared/controllers/search/travel_date_picker_controller.js"
import "@front/shared/controllers/search_form_toggle_controller.js"
import "@front/shared/controllers/set_hash_controller.js"
import "@front/shared/controllers/slider_controller.js"
import "@front/shared/controllers/switch_locale_controller.js"
import "@front/shared/controllers/transfer_guest_stepper_controller.js"
import "@front/shared/controllers/transfer_passengers_controller.js"
import "@front/shared/css-document-width.js"
import "@front/shared/details.js"
import "@front/shared/disable_with.js"
import "@front/shared/failed_image_handler.js"
import "@front/shared/fixer.js"
import "@front/shared/global_events.js"
import "@front/shared/gmap_types_switcher.js"
import "@front/shared/google_onetap.js"
import "@front/shared/guest_names_controller.js"
import "@front/shared/hash_nav.js"
import "@front/shared/hb_utils/group_summary.js"
import "@front/shared/hb_utils/is_visible.js"
import "@front/shared/hb_utils/load_js.js"
import "@front/shared/hb_utils/pluralize.js"
import "@front/shared/hb_utils/svg_icon.js"
import "@front/shared/hb_utils/text_direction.js"
import "@front/shared/hb_utils/unwrap_element.js"
import "@front/shared/hb_utils/utc_date.js"
import "@front/shared/hb_utils/uuid.js"
import "@front/shared/load_sprite.js"
import "@front/shared/maps.js"
import "@front/shared/noscroll_ios_shift.js"
import "@front/shared/notifications.js"
import "@front/shared/offers-map.js"
import "@front/shared/proof_of_work.js"
import "@front/shared/publications.js"
import "@front/shared/rack_miniprofiler.js"
import "@front/shared/select-has-value.js"
import "@front/shared/state.js"
import "@front/shared/switch_currency.js"
import "@front/shared/taksit_banner.js"
import "@front/shared/toggle-items.js"
import "@front/shared/topbnr.js"
import "@front/shared/track_activity.js"
import "@front/shared/turbo_setup.js"
import "@front/shared/turkish_validations.js"
import "@front/shared/variant_switcher.js"
import "@front/shared/website_url.js"
